import { render, staticRenderFns } from "./SurveyFormCreate.vue?vue&type=template&id=256dff85&"
import script from "./SurveyFormCreate.vue?vue&type=script&lang=js&"
export * from "./SurveyFormCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports